import Player from 'video.js/dist/types/player';

export const createVolumeControl = (player: Player) => {
  const volumeControl = document.createElement('div');
  volumeControl.className = 'vjs-custom-volume-control';

  const volumeButton = document.createElement('button');
  volumeButton.className = 'vjs-volume-button vjs-control vjs-button';
  volumeButton.title = 'Volume';

  const updateVolumeIcon = () => {
    const isMuted = player.muted();
    const volume = player.volume();

    if (isMuted || volume === 0) {
      volumeButton.innerHTML = '<span class="vjs-icon-placeholder"><i class="fa-regular fa-volume-xmark"></i></span>';
    } else {
      volumeButton.innerHTML = '<span class="vjs-icon-placeholder"><i class="fa-regular fa-volume-high"></i></span>';
    }
  };

  volumeButton.onclick = e => {
    e.stopPropagation();
    const isMuted = player.muted();

    if (isMuted) {
      player.muted(false);
      player.volume(1.0);
    } else {
      player.muted(true);
    }

    updateVolumeIcon();
  };

  player.on('volumechange', () => {
    updateVolumeIcon();
  });

  if (!player.muted()) {
    player.volume(1.0);
  }

  updateVolumeIcon();

  volumeControl.appendChild(volumeButton);

  return volumeControl;
};
